import * as React from "react"
import { PropsWithChildren } from "react"

import { Button } from "./styles"
import Icon from "../../core/icon"

export interface ButtonConfig {
  icon: string;
  href: string;
}

export default function ButtonComponent(props: PropsWithChildren<ButtonConfig>) {
  return (
    <Button href={props.href}>
      {props.icon ? <Icon size={20} glyph={props.icon}/> : null}
      {props.children}
    </Button>
  )
}
